import React from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {

  const navigate=useNavigate();
  const hamdleNavigateDashboard = (e) => {
        navigate('/history')
      };
  const hamdleNavigateRoleReview = (e) => {
        navigate('/preview')
      };
  return (
    <SectionWrap component="section">
      <ContainerWrap>
        <RowWrap>
          <Col6Wrap>
            <LpTitle variant="h1">What is Lorem Ipsum?</LpTitle>
            <LpContent variant="body1">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
              blanditiis tenetur unde suscipit, quam beatae rerum inventore
              consectetur, neque doloribus, cupiditate numquam dignissimos
              laborum fugiat deleniti? Eum quasi quidem quibusdam.
            </LpContent>
            <LpContent variant="body1">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </LpContent>
            <LpContent variant="body1">
              {" "}
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
              blanditiis tenetur unde suscipit.
            </LpContent>
          </Col6Wrap>
          <Col6Wrap>
            <IframeHolder>
              <iframe
                allowfullscreen="true"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  bottom: "0",
                  right: "0",
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                title="Video"
                src="https://www.youtube.com/embed/tgbNymZ7vqY"
              ></iframe>
            </IframeHolder>
          </Col6Wrap>
          <Col12Wrap>
            <CustomBtn type="submit" variant="outlined" onClick={hamdleNavigateDashboard}>
              Go to Dashboard to See/Modify Existing Summaries
            </CustomBtn>
            
          </Col12Wrap>
          <Col12Wrap>
           
            <CustomBtn type="submit" variant="outlined" onClick={hamdleNavigateRoleReview}>
              Start a RoleReview for Your Role
            </CustomBtn>
          </Col12Wrap>
        </RowWrap>
      </ContainerWrap>
    </SectionWrap>
  );
};

export default LandingPage;

const SectionWrap = styled(Box)(() => ({
  padding: "50px 0",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  paddingTop: "50px",
  textAlign: "center",
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "50%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 991px)": {
    maxWidth: "100%",
  },
}));
const LpTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontWeight: "600",
  lineHeight: "1.179",
  color: "#000000",
  marginBottom: "15px",
}));
const LpContent = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: "300",
  lineHeight: "1.4",
  color: "#6a6a6a",
  letterSpacing: '0.6px',
  marginBottom: "10px",
  "@media (min-width: 992px)": {
    "&:last-of-type": {
      marginBottom: "0",
    },
  },
  "@media (max-width: 991px)": {
    "&:last-of-type": {
      marginBottom: "30px",
    },
  },
}));
const IframeHolder = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  paddingTop: "56.25%",
}));
const CustomBtn = styled(Button)(() => ({
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 25px",

  boxShadow: "none !important",
}));